import { render, staticRenderFns } from "./shopStoreFreight.vue?vue&type=template&id=7000e914&"
import script from "./shopStoreFreight.vue?vue&type=script&lang=js&"
export * from "./shopStoreFreight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports